const moviesApiBaseUrl = (process.env.REACT_APP_MOVIES_API_BASE_URL || '')
  .trim()
  .replace(/\/+$/, '');

export const getMoviesApiUrl = (path) => {
  return `${moviesApiBaseUrl}${path}`;
};

export const getUnavailableApiMessage = () => {
  return 'Endpoint administrativo indisponivel. O fluxo recomendado e frontend + API no mesmo dominio (same-origin) via Vercel. Em dev/local, execute com Vercel serverless ou configure REACT_APP_MOVIES_API_BASE_URL para uma API confiavel.';
};

export const parseJsonResponse = async (response) => {
  try {
    return await response.json();
  } catch (_error) {
    return null;
  }
};
